import ClientCoreModel from "./client-core-model";
import config from "../config"

/* Helper to make all the API calls */
export default class APIHelper extends ClientCoreModel {
    readonly apiEndpoint = config.apiEndpoint;

    /* API call to get the promotions */
    public getPromotions = async () => {
        return this.axios.get(this.apiEndpoint + "channel/person-dashboard/promotions");
    }

    /* API call to get todos*/
    public getTodo = async () => {
        return this.axios.get(this.apiEndpoint + "channel/person-dashboard/todo");
    }

    /* API call to get user details*/
    public getUserDetails = async (userEmail: string) => {
        return this.axios.get(this.apiEndpoint + "channel/person-dashboard/users/" + userEmail);
    }

    /* API call to get user details*/
    public getUserPhoto = async (userEmail: string) => {
        return this.axios.get(this.apiEndpoint + "channel/person-dashboard/users/" + userEmail + "/photos", { responseType: "blob" });
    }

    /* API call to get person account summary details*/
    public getAccountSummary = async () => {
        return this.axios.get(this.apiEndpoint + "channel/person-account/accountsummary");
    }
}